import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DirectivesModule } from '../../directives/directives.module';
import { PoprToastContainerDirective } from './toast/popr-toast-container.directive';
import { PoprToastComponent } from './toast/popr-toast.component';
import { PoprModalComponent } from './modal/popr-modal.component';
import { PoprModalContainerDirective } from './modal/popr-modal-container.directive';
import { PoprContainerMediator } from './popr-container.mediator';
import {
  CheckMarkCircleIcon,
  CircleExclamationIcon,
  CrossIcon,
  ExclamationTriangleIcon,
  IconModule,
  IconRegistry
} from '@ciam/library';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        IconModule
    ],
  declarations: [
    PoprModalComponent,
    PoprModalContainerDirective,

    PoprToastComponent,
    PoprToastContainerDirective,
  ],
  providers: [
    { provide: 'poprContainerMediator', useClass: PoprContainerMediator },
    { provide: 'poprToastTimeout', useValue: 3_000 }
  ],
  exports: [
    PoprModalContainerDirective,
    PoprToastContainerDirective,
  ]
})
export class PoprModule {
  constructor(private iconRegistry: IconRegistry) {
    this.iconRegistry.register(
      CrossIcon,
      CircleExclamationIcon,
      ExclamationTriangleIcon,
      CheckMarkCircleIcon
    );
  }
}
